import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';

// Глобальний репорт помилок мініапки на сервер (для діагностики iOS WebView).
export function reportClientError(message: string, stack?: string) {
  try {
    fetch('/api/client-error', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ message, stack: stack || '', url: location.href }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
}

window.addEventListener('error', (e) => {
  reportClientError(`window.error: ${e.message}`, (e.error && e.error.stack) || `${e.filename}:${e.lineno}:${e.colno}`);
});
window.addEventListener('unhandledrejection', (e: any) => {
  const r = e?.reason;
  reportClientError(`unhandledrejection: ${r?.message || r}`, r?.stack);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
